import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ExperimentsListPage = lazy(
  () => import('~/features/catalog-enrichment/pages/experiments-list-page'),
);

/**
 * Experiments list filters, kept in the URL so Back restores them. Every field is
 * optional and `.catch(undefined)` so a malformed link just opens the default list.
 */
const experimentsSearchSchema = z.object({
  page: z.coerce.number().int().min(1).optional().catch(undefined),
  size: z.coerce.number().int().min(1).max(100).optional().catch(undefined),
  status: z
    .array(z.enum(['DRAFT', 'CREATED', 'RUNNING', 'COMPLETED', 'CANCELLED', 'REJECTED', 'FAILED']))
    .optional()
    .catch(undefined),
  q: z.string().optional().catch(undefined),
  createdAfter: z.string().optional().catch(undefined),
  createdBefore: z.string().optional().catch(undefined),
  archived: z.enum(['ACTIVE', 'ARCHIVED', 'ALL']).optional().catch(undefined),
  legacyWorkflowId: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_authenticated/_tenant/catalog-enrichment/experiments/')({
  validateSearch: experimentsSearchSchema,
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ExperimentsListPage />
    </Suspense>
  ),
});
